import { render, staticRenderFns } from "./order-view-account.vue?vue&type=template&id=28062934&scoped=true&"
import script from "./order-view-account.vue?vue&type=script&lang=js&"
export * from "./order-view-account.vue?vue&type=script&lang=js&"
import style0 from "./order-view-account.vue?vue&type=style&index=0&id=28062934&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28062934",
  null
  
)

export default component.exports